<template>
  <v-combobox
    v-model="selectedList"
    :items="dataList"
    :label="label"
    :multiple="!singleSelect"
    :item-text="itemText"
    :disabled="isDisable"
    @change="haddleClick"
  >
    <template v-if="!singleSelect" v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon :color="selectedList.length > 0 ? 'indigo darken-4' : ''">
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title> Select All </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-if="!singleSelect" v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ item[itemText] }}</span>
      <span v-if="index === 1" class="grey--text text-caption">
        (+{{ selectedList.length - 1 }} others)
      </span>
    </template>
  </v-combobox>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: null,
    },
    itemText: {
      type: String,
      default: null,
    },
    itemValue: {
      type: String,
      default: null,
    },
    dataList: {
      type: Array,
      default: null,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedList: [],
  }),
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.resolveSelectedList(newVal);
      },
    },
    dataList(newList) {
      if (newList) {
        this.resolveSelectedList(this.value);
      }
    },
  },
  computed: {
    likesAll() {
      return this.selectedList.length === (this.dataList || []).length;
    },
    likesSome() {
      return this.selectedList.length > 0 && !this.likesAll;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    resolveSelectedList(val) {
      if (!val || val.length === 0) {
        this.selectedList = this.singleSelect ? null : [];
        return;
      }
      // If itemValue is set and the values are primitives, look up full objects from dataList
      if (this.itemValue && typeof val[0] !== "object") {
        const matched = (this.dataList || []).filter((item) =>
          val.includes(item[this.itemValue])
        );
        if (this.singleSelect) {
          this.selectedList = matched[0] || null;
        } else {
          this.selectedList = matched;
        }
      } else if (this.singleSelect) {
        this.selectedList = Array.isArray(val) ? val[0] || null : val;
      } else {
        this.selectedList = [...val];
      }
    },
    emitValue() {
      let list = this.selectedList;
      if (this.singleSelect) {
        list = list ? [list] : [];
      }
      // Keep only one when singleSelect and combobox somehow returns array
      if (this.singleSelect && Array.isArray(this.selectedList)) {
        this.selectedList =
          this.selectedList.length > 0
            ? this.selectedList[this.selectedList.length - 1]
            : null;
        list = this.selectedList ? [this.selectedList] : [];
      }
      const emitted = this.itemValue
        ? list.map((item) => item[this.itemValue])
        : list;
      this.$emit("CheckVisibility", true);
      this.$emit("checkSelectedList", emitted);
    },
    toggle() {
      if (this.singleSelect) return;
      this.$nextTick(() => {
        this.selectedList = this.likesAll ? [] : (this.dataList || []).slice();
        this.emitValue();
      });
    },
    haddleClick() {
      this.emitValue();
    },
  },
};
</script>
